import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../../scss/industry.scss';
import Color from '@tool/color';
import { newRate } from '@tool/index';
import { DtaileIcon } from '@/styled/icon';

interface IProps {}
interface IState {}

const BannerGroup = (props: IProps, state: IState) => {
  const navi = useNavigate();

  const goIndustry = () => {
    window.location.href = '/index/industry-research/0';
  };

  const onMacro = () => {
    window.location.href = '/market/macro';
  };

  const goWealfare = () => {
    window.location.href = '/index/wealfare-insight/0';
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="dash-industry-warp industry-011">
      <section className="banner-group">
        <section className="item" onClick={goIndustry}>
          <section className="left">
            <h4>
              生成行业数据白皮书 <span>new</span>
            </h4>
            <p>自定义生成 | 多行业比对 | 多城市比</p>
          </section>
          <a style={{ color: Color.secondary }}>
            查看详情
            <DtaileIcon color={Color.secondaryColor(0.5)}/>
          </a>
        </section>
        <section className="item" onClick={onMacro}>
          <section className="left">
            <h4>宏观 · 社保</h4>
            <p>GDP | CPI | 社平工资 |  社保基数 …</p>
          </section>
          <a style={{ color: Color.primary }}>
            查看详情
            <DtaileIcon />
          </a>
        </section>
        <section className="item" onClick={goWealfare}>
          <section className="left">
            <h4>企业福利</h4>
            <p>企业预算 | 员工喜好</p>
          </section>
          <a style={{ color: Color.success }}>
            查看详情
            <DtaileIcon color={Color.successColor(0.5)}/>
          </a>
        </section>
      </section>
    </section>
  );
};

export default observer(BannerGroup);
